import { Button, Dialog, DialogContent, DialogActions, Typography} from '@mui/material';
import React from 'react';
import { AlertDialog } from './AlertDialog';

export type OpenAttachmentPropsType = {
  name: string
  openFile: () => void
  closeFile: () => void
  removeAttachment: () => void
  downloadAttachment: (url: string, fileName: string) => void
  currentAttachedUrl: string
  currentAttachedType: string
}

export const OpenAttachment = (props: OpenAttachmentPropsType) => {
  const [open, setOpen] = React.useState(false);
  // const currentAttachedUrl = useSelector<AppRootState, string>(state => state.workItems.currentAttachmentUrl)
  // const currentAttachedType = useSelector<AppRootState, string>(state => state.workItems.currentAttachmentType)

  const handleClose = () => {
    props.closeFile()
    setOpen(false)
  }
  const onOpenAttachment = () => {
    setOpen(true)
    props.openFile()
  }
  const onDownloadAttachment = () => {
    props.downloadAttachment(props.currentAttachedUrl, props.name)
    setOpen(false)
  }

  return (
    <div  >
      <Typography
        onClick={onOpenAttachment}
        color="textPrimary"
        className='navlink'
        variant="body1"
        style={{ paddingLeft: '8px' }}>{props.name}
      </Typography>
      <Dialog
        fullWidth
        maxWidth='xl'
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogActions>
          {props.currentAttachedType === 'jpeg' || props.currentAttachedType === 'png' || props.currentAttachedType === 'gif'
            || props.currentAttachedType === 'bmp' || props.currentAttachedType === 'pdf' ? <Button onClick={onDownloadAttachment} variant="contained" color="info" autoFocus>
            Download
          </Button>  : <></>}
          
          <Button variant="contained" color="primary" autoFocus>
            <AlertDialog removeAttachment={props.removeAttachment} fileName={props.name} />
          </Button>
          <Button onClick={handleClose} variant="contained" color="primary" autoFocus>
            X
          </Button>
        </DialogActions>
        <DialogContent
          style={{ textAlign: 'center' }}
        >
          {props.currentAttachedType === 'jpeg' || props.currentAttachedType === 'png' || props.currentAttachedType === 'gif'
            || props.currentAttachedType === 'bmp' ? <img src={props.currentAttachedUrl} />
            : props.currentAttachedType === 'pdf' ?
              <embed src={props.currentAttachedUrl} width="800px" height="2100px" />
              : <div>It looks like this file doesn't have a preview we can show you.
                <div>
                  <Button onClick={onDownloadAttachment} style={{ marginTop: '40px' }} variant="contained" color="info" autoFocus>
                    Download attachment
                  </Button>
                </div>
              </div>
          }
        </DialogContent>
      </Dialog>
    </div>
  );
}
